import { render, staticRenderFns } from "./NavigaitionLink.vue?vue&type=template&id=9eb96506&scoped=true&"
import script from "./NavigaitionLink.vue?vue&type=script&lang=ts&"
export * from "./NavigaitionLink.vue?vue&type=script&lang=ts&"
import style0 from "./NavigaitionLink.vue?vue&type=style&index=0&id=9eb96506&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb96506",
  null
  
)

export default component.exports